import React from 'react'
import { Controller, useForm } from 'react-hook-form'
import AppInputMask from '@/components/ui/InputMask'
import { Typography } from '@mui/material'
import { HelpBlock } from '@/components/help/HelpBlock'
import {
  Form,
  FormGrid,
  Input,
  InputGrid,
  NextButton,
  ProgressGrid,
  Title,
} from '@/components/registrant/Registrant.styled'
import Link from 'next/link'
import Grid from '@mui/material/Grid2'
import { AppButton } from '@/components/ui'

export interface FormValues {
  phone: string
}

interface Props {
  onSubmit: (data: FormValues) => void
}

const SignInForm: React.FC<Props> = ({ onSubmit }) => {
  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm<FormValues>({
    defaultValues: {
      phone: '',
    },
  })

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      <FormGrid container direction="column" sx={{ width: '100%' }}>
        <Title variant="h2">Sign In & Check Progress</Title>
        <InputGrid>
          <Controller
            name="phone"
            control={control}
            rules={{
              required: 'Mobile number is required',
            }}
            render={({ field }) => (
              <Input
                {...field}
                fullWidth
                label="Your mobile number"
                variant="outlined"
                error={Boolean(errors.phone && errors.phone.message)}
                helperText={errors.phone && errors.phone.message}
                placeholder="+1 XXX-XXX-XXXX"
                slotProps={{
                  input: {
                    inputComponent: AppInputMask as any,
                  },
                }}
              />
            )}
          />
          <NextButton fullWidth variant="contained" type="submit">
            Next
          </NextButton>
        </InputGrid>
        <ProgressGrid>
          <Typography>Don't have an account yet?</Typography>
          <AppButton fullWidth LinkComponent={Link} sx={{ mt: 4 }} href="/registrant/registration" variant="outlined">
            Register Participant
          </AppButton>
        </ProgressGrid>
        <Grid>
          <HelpBlock />
        </Grid>
      </FormGrid>
    </Form>
  )
}

export default SignInForm
